import { FaBatteryHalf } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import InstallationCameraStatusSection from "./InstallationCameraStatusSection";
import { InstallationPickerRow } from "./InstallationPickerSheet";

function formatBatterySubtitle(batteryLevel, t) {
  if (
    batteryLevel === undefined ||
    batteryLevel === null ||
    Number.isNaN(batteryLevel)
  ) {
    return t("installation_state_battery_subtitle_unknown");
  }
  return t("installation_state_battery_subtitle_value", {
    percent: Math.trunc(batteryLevel),
  });
}

const InstallationStateSection = ({
  routeCameraId,
  status,
  onStatusSave,
  batteryLevel,
  loading,
  disabled,
  saving,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const openBatteryDetail = () => {
    history.push(`/app/installationdetails/${routeCameraId}/state/battery`, {
      batteryLevel,
    });
  };

  return (
    <>
      <InstallationCameraStatusSection
        status={status}
        onStatusSave={onStatusSave}
        disabled={disabled}
        saving={saving}
      />
      <InstallationPickerRow
        icon={FaBatteryHalf}
        iconVariant="battery"
        title={t("installation_state_battery_label")}
        subtitle={
          loading
            ? t("installation_loading")
            : formatBatterySubtitle(batteryLevel, t)
        }
        onClick={openBatteryDetail}
        disabled={loading || disabled || saving}
        divided
      />
    </>
  );
};

export default InstallationStateSection;
